module.exports = __webpack_public_path__ + "img/logo-draft-colored.8b5eb289.svg";